<div [hidden]="moduleManager.showLoader" class="w-100 h-100">
    <!-- dropown and selected tags -->
    <div style="padding: 8px;">
        <div style="min-width: 285px;">
            <div class="ml-n6">
                <cv-group-selector #groupSelectorDTOComp
                    *ngIf="dataReady"
                    [showLabels]="false"
                    [pageName]="moduleKey"
                    [baseGroupType]="0"
                    [settingsManager]="settingsManager"
                    [specificLevel]="1"
                    [hasMultiSelect]="true"
                    [selectedGroupsDto]="selectedAgentsDTO"
                    [selectAllOnEmpty]="false"
                    (selectedGroupsChanged)="agentGroupsChanged($event)"
                    (selectedGroupsLoaded)="initialGroupsLoaded($event)">
                </cv-group-selector>
            </div>
            <div *ngIf="myChips.length > 0" style="margin-left: -5px">
                <cxone-selected-tags 
                    [tagsSource]="myChips" 
                    [removable]="true" 
                    [hasSquareElement]="true"
                    (tagDeleted)="onTagDeleted($event)"
                    label="name">
                </cxone-selected-tags>
            </div>
        </div>
    </div>

    <!-- highchart object -->
    <highcharts-chart 
        [style.display]="noAgentsSelected ? 'none' : 'block'"
        [Highcharts]="highcharts"
        [options]="config"
        (chartInstance)="setChartInstance($event)"
        [(update)]="updateChart"
        style="padding: 5px; height: calc(100% - 93px)" class="w-100">
    </highcharts-chart>
    <app-module-error *ngIf="noAgentsSelected && dataReady" [noAgentsSelected]="noAgentsSelected" class="d-flex" style="justify-content: center; height: calc(100% - 93px);"></app-module-error>
</div>
